import { getHasSendTimeOptimization } from 'modules/campaigns/editor/utils';
import { useExperimentTakeover } from 'modules/experiments/takeover';
import { useEffect, useState } from 'react';
import { BUTTON_VARIANTS } from 'ui/button';
import { ExperimentFlask } from 'ui/icons';
import { Tooltip } from 'ui/tooltip';
import { useLocaleSettingsContext } from 'modules/campaigns/lib/contexts/LocaleSettingsContext';

import {
  useCampaignContext,
  useEditorContext,
  useTemplateContext,
  useUnsavedPromptContext,
} from '../../../context';
import { AddExperimentButton } from './Experiments.styled';

export const ADD_EXPERIMENT_BUTTON_TEST_ID = 'add-experiment-button';

export const AddExperiment = () => {
  const {
    campaign: { id, name, campaignState },
    campaign,
  } = useCampaignContext();

  const { isExperimentModalOpen } = useEditorContext();
  const { openExperimentCreationModal } = useExperimentTakeover();
  const {
    templateState: { isDefaultTemplate, templateHasContentIssues },
    templateAndContent,
  } = useTemplateContext();
  const { hasLocales } = useLocaleSettingsContext();

  const [templateDataResolved, setTemplateDataResolved] = useState(false);

  const isExperimentButtonDisabled = isDefaultTemplate || templateHasContentIssues;
  const experimentButtonTooltip = isDefaultTemplate
    ? 'A template must be attached before an experiment can be created.'
    : 'The template attached must not have any errors before an experiment can be created.';

  useEffect(() => {
    if (Object.keys(templateAndContent).length > 0) {
      setTemplateDataResolved(true);
    }
  }, [templateAndContent]);

  useEffect(() => {
    if (isExperimentModalOpen && templateDataResolved)
      openExperimentCreationModal({
        id,
        name,
        campaignState,
        isCampaignSTOEnabled: getHasSendTimeOptimization(campaign),
        hasLocales,
        isCampaignValid: !isExperimentButtonDisabled,
      });
  }, [isExperimentModalOpen, isExperimentButtonDisabled, hasLocales, templateDataResolved]);

  const { transitionTo } = useUnsavedPromptContext();
  const onAdd = () =>
    transitionTo(() => {
      openExperimentCreationModal({
        id,
        name,
        campaignState,
        isCampaignSTOEnabled: getHasSendTimeOptimization(campaign),
        hasLocales,
        isCampaignValid: true,
      });
    });

  return (
    <Tooltip isEnabled={isExperimentButtonDisabled} tooltipContent={experimentButtonTooltip}>
      <AddExperimentButton
        isDisabled={isExperimentButtonDisabled}
        data-test={ADD_EXPERIMENT_BUTTON_TEST_ID}
        variant={BUTTON_VARIANTS.SECONDARY}
        onClick={onAdd}
      >
        <ExperimentFlask />
        Add experiment
      </AddExperimentButton>
    </Tooltip>
  );
};
